var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"date-picker"}},[_c('i',{staticClass:"fa fa-calendar"}),_vm._v(" \n  "),_c('span'),_vm._v(" "),_c('i',{staticClass:"fa",class:{ 'fa-caret-down': !_vm.showPicker, 'fa-caret-up': _vm.showPicker }})])}
var staticRenderFns = []

export { render, staticRenderFns }